module.exports = __webpack_public_path__ + "img/new2.de6b0255.webp";